import dynamic from 'next/dynamic';
import { CreditCardInfoProps } from './CreditCardInfo.types';

export const CreditCardInfo = dynamic<CreditCardInfoProps>(() =>
  import('./CreditCardInfo').then(module => module.CreditCardInfo)
);
